import { Injectable, PLATFORM_ID, computed, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { toSignal } from '@angular/core/rxjs-interop';
import { catchError, of, shareReplay, timeout } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface PublicStatus {
  status?: string;
  metrics?: { period_days: number; incident_free_percent: number };
}

/** Public status of the platform, fetched once in the browser and shared by the new design. */
@Injectable({ providedIn: 'root' })
export class AncStatusService {
  private readonly http = inject(HttpClient);
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  private readonly status$ = this.isBrowser
    ? this.http.get<PublicStatus>(`${environment.apiUrl}/status`).pipe(
        timeout(5000),
        catchError(() => of(null)),
        shareReplay(1)
      )
    : of(null);

  readonly status = toSignal(this.status$, { initialValue: null });

  /** Null until the API answers. */
  readonly operational = computed(() => {
    const status = this.status()?.status;
    return status ? status === 'operational' : null;
  });
}
